import { Api } from '../generated/api';

type Params = {
  baseUrl: string;
};

export const createChatgenieAPI = ({ baseUrl }: Params) => {
  const api = new Api({
    baseURL: baseUrl
  });
  return api;
};
